<div
  class="tw-relative tw-rounded-xl tw-bg-cover tw-bg-center tw-overflow-hidden tw-isolate"
  [ngClass]="
    layout === 'stack'
      ? 'tw-w-full tw-aspect-[358/164] tw-px-6 tw-py-4'
      : 'tw-w-[320px] tb:tw-w-[280px] tw-aspect-[320/202] tw-px-6 tw-py-[22px]'
  "
  style="background-image: url(&quot;/images/card-bg/goldCredits.png&quot;)"
>
  <app-card-glare
    #glare
    glareCore="rgba(255,255,255,.32)"
    glareSoft="rgba(190,246,240,.14)"
    glareBlend="screen"
  ></app-card-glare>

  <!-- TotalCredits -->
  <div class="tw-flex tw-h-full tw-flex-col tw-items-start">
    <span class="tw-font-medium tw-text-[11px] tw-leading-4 tw-text-hero-text-label">
      {{ "goldCredits" | i18n | uppercase }}
    </span>

    <span
      [ngClass]="layout === 'stack' ? 'tw-mt-4' : 'tw-mt-2.5'"
      class="tw-font-bold tw-text-[32px] tw-leading-10 tw-text-color-text-on-dark tw-tabular-nums tw-font-D-DIN-PRO tw-antialiased"
    >
      <app-odometer-number
        [value]="creditsService.totalGoldCredits()"
        (committed)="glare.play()"
      ></app-odometer-number>
    </span>

    <!-- Redeem For -->
    <div class="tw-mt-auto tw-flex tw-flex-col">
      <span class="tw-font-semibold tw-text-2xs tw-leading-[14px] tw-text-hero-text-meta">
        {{ "redeemFor" | i18n | uppercase }}
      </span>
      <span class="tw-font-medium tw-text-[13px] tw-leading-[18px] tw-text-color-text-on-dark">
        {{ "pluginsAndBundles" | i18n }}
      </span>
    </div>
  </div>
</div>
